import React, { useEffect, useState } from 'react'
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import { Card } from '@mui/material';
import { ArrowCircleRightOutlined } from '@mui/icons-material';

const Index = () => {
    const params = useParams()
    const Navigate = useNavigate()
    const queryString = window.location.search;
    const query = new URLSearchParams(queryString);
    const businessId = query.get("businessId");
    const [allData, setAllData] = useState({})
    const [allBusinessData, setAllBusinessData] = useState({})
    const getDetailById = async () => {
        try {
            const res = await service.users.getDetailById(params.id);
            const resBus = await service.users.getBusinessById(businessId);


            setAllBusinessData(resBus?.data?.data)
            setAllData(res?.data?.data)
        } catch (error) {
            console.error('Error fetching user details:', error);
        }
    };

    useEffect(() => {
        if (params?.id) {
            getDetailById();
        }
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Card className="glassmorphism-card" sx={{ padding: 3, boxShadow: 2 }}>

                <SoftBox px={3} py={2}>
                    <SoftBox sx={{ display: 'flex', gap: 2 }}>
                        <SoftBox
                            variant="outlined"
                            color="info"
                            style={{ cursor: "pointer" }}
                            onClick={() => Navigate(-1)}
                        >
                            <ArrowCircleRightOutlined
                                style={{ transform: "rotate(180deg)", color: "#141414" }}
                            />
                        </SoftBox>
                        <SoftTypography variant="h6" fontWeight="bold" mb={3}>
                            Business User Profile
                        </SoftTypography>
                    </SoftBox>

                    <SoftBox display="flex" flexDirection="column" gap={2}>
                        {[{
                            label: "Name",
                            value: allData?.firstName
                        }, {
                            label: "Email",
                            value: allData?.email
                        }, {
                            label: "Mobile Number",
                            value: allData?.mobileNumber
                        }, {
                            label: "Sub Title",
                            value: allBusinessData?.businessName
                        }, {
                            label: "Category",
                            value: allBusinessData?.category?.name
                        }, {
                            label: "Sub-Category",
                            value: allBusinessData?.subCategory?.name
                        }, {
                            label: "Reservation Allowed",
                            value: allBusinessData?.reservationAllowed ? 'True' : 'False'
                        }, {
                            label: "Amenities",
                            value: allBusinessData?.amenities?.[0]?.name
                        }].map((item, i) => (
                            <SoftBox display="flex" gap key={i}>
                                <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">{item.label}</SoftTypography>
                                <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">:</SoftTypography>
                                <SoftTypography variant="button" fontWeight="regular" color="text">{item.value}</SoftTypography>
                            </SoftBox>
                        ))}

                        <SoftBox>
                            <SoftTypography variant="caption" fontWeight="bold" mb={1}>Images</SoftTypography>
                            <SoftBox display="flex" gap={1} flexWrap="wrap">
                                {Array.isArray(allBusinessData?.images) && allBusinessData.images.length > 0 && (
                                    allBusinessData.images.map((img, index) => (
                                        <img
                                            key={img._id || index}
                                            src={img.url}
                                            alt={`Business Logo ${index + 1}`}
                                            style={{
                                                width: '50px',
                                                height: '50px',
                                                objectFit: 'contain',
                                                border: '1px solid #ccc'
                                            }}
                                        />
                                    ))
                                )}
                            </SoftBox>
                        </SoftBox>

                        <SoftBox display="flex" flexDirection="column">
                            <SoftTypography variant="h6" fontWeight="bold">Address</SoftTypography>
                            <SoftTypography variant="body2">
                                {allBusinessData?.address?.addLine}, {allBusinessData?.address?.city?.name}, {allBusinessData?.address?.state?.name}, {allBusinessData?.address?.country?.name}
                            </SoftTypography>
                        </SoftBox>

                        <SoftBox display="flex" flexDirection="column">
                            <SoftTypography variant="h6" fontWeight="bold">Description</SoftTypography>
                            <SoftTypography variant="body2" mt={1} dangerouslySetInnerHTML={{ __html: allBusinessData?.description }} />
                        </SoftBox>
                    </SoftBox>

                    <SoftTypography variant="h6" fontWeight="bold" mt={4} mb={2}>
                        Operating Hours
                    </SoftTypography>

                    {Array.isArray(allBusinessData?.operatingHours) &&
                        allBusinessData?.operatingHours?.map((dayData) => (
                            <SoftBox
                                key={dayData._id}
                                display="flex"
                                gap={3}
                                alignItems="center"
                                mb={1}
                                px={1}
                            >
                                <SoftTypography sx={{ fontSize: 14, fontWeight: 'bold', minWidth: '80px' }} variant="caption">
                                    {dayData.day}
                                </SoftTypography>
                                <SoftTypography sx={{ fontSize: 14, color: 'gray', minWidth: '80px' }} variant="caption">
                                    {dayData.openingHours || '-'}
                                </SoftTypography>
                                <SoftTypography sx={{ fontSize: 14, color: 'gray', minWidth: '80px' }} variant="caption">
                                    {dayData.closingHours || '-'}
                                </SoftTypography>
                            </SoftBox>
                        ))}

                    <SoftBox display="flex" flexDirection="column" gap={2} mt={2}>
                        <SoftBox>
                            <SoftTypography variant="h6" fontWeight="bold">Terms And Conditions</SoftTypography>
                            <SoftTypography variant="body2" dangerouslySetInnerHTML={{ __html: allBusinessData?.termsAndConditions }} />
                        </SoftBox>
                        <SoftBox>
                            <SoftTypography variant="h6" fontWeight="bold">Privacy Policy</SoftTypography>
                            <SoftTypography variant="body2">{allBusinessData?.privacyPolicy}</SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            </Card>
        </DashboardLayout>
    )
}

export default Index